// extracted by mini-css-extract-plugin
module.exports = {"remove":"styled_remove__1i932"};